<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a line to invoice {{ipfr.ipfc_code }} </p>
    <v-form ref="addIpfr" v-model="addIpfrValid">
     
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="ipfr.hfrt_code" :items="hfrt_codeKeuzes" item-value="hfrt_code" item-text="hfrttaal_oms" label="Item" dense></v-select>
      </v-col>
     </v-row>

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="ipfr.ipfr_oms" label="Description" dense></v-text-field>
      </v-col>
     </v-row>    

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="ipfr.ipfr_bedrag_excl" label="Amount excl VAT" prefix="EUR" dense></v-text-field>
      </v-col>
     </v-row>    
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addIpfr" :disabled="!addIpfrValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addIpfrValid: false,
      ipfc_encrid: null,
      hfrt_codeKeuzes: [],
      ipfr: {},
      hfrt_codeRules: [
          v => (v && v.length >= 3) || "An Item is requird"
      ]
    }
  },
  methods: {
    open(ipfc_encrid) {
      caches.log(ipfc_encrid)
      // var deze = this;
      // this.$emit("showSnackbar");
      // this.dialog = true;
      // this.$axios
      //   .post("ares/json/ares/task/inpt/ipfc/ipfr/getIpfcToAddIpfr.p", {
      //     header: {
      //       token: this.$session.get("ARES"),
      //       clientSessionId: this.$session.id(),
      //       request: "getIpfcToAddIpfr"
      //     },
      //     getIpfcToAddIpfr: {
      //       ipfc_encrid: ipfc_encrid
      //     }
      //   })
      //   .then(res => {
      //     if (res.data.error) {
      //       console.log(res.data.error);
      //     } else {
      //       this.ipfr = res.data.getIpfcToAddIpfr;
      //       res.data.getIpfcToAddIpfr.hfrt_codeKeuzes.forEach(function(hfrt) {
      //       deze.hfrt_codeKeuzes.push(hfrt); 
      //      });
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    addIpfr() { 
      // this.$axios
      //   .post("ares/json/ares/task/inpt/ipfc/ipfr/addIpfr.p", {
      //     header: {
      //       token: this.$session.get("ARES"),
      //       clientSessionId: this.$session.id(),
      //       request: "addIpfr"
      //     },
      //     addIpfr: {
      //       ipfc_encrid: this.ipfr.ipfc_encrid,
      //       hfrt_code: this.ipfr.hfrt_code,
      //       ipfr_oms: this.ipfr.ipfr_oms,
      //       ipfr_bedrag_excl: parseFloat(this.ipfr.ipfr_bedrag_excl)
      //     }
      //   })
      //   .then(res => {
      //     if (res.data.error) {
      //       console.log(res.data.error);
      //     }  else { 

      //        if (res.data.addIpfr.color == "success") { 
      //           setTimeout(() => { this.$router.reload('/task/inpt/ipfc/onIpfcTmp/' + res.data.addIpfr.ipfc_encrid);  }, 2000);      
      //        }         
      //        this.$store.dispatch('setSnackbar', {
      //         showing: true,
      //         text: res.data.addIpfr.text,
      //         color: res.data.addIpfr.color
      //       }); 
      //       this.dialog = false;
      //     }
      //   })
    },
  }
}
</script>

